import React from 'react';
import { LineDiv } from './styles';

const Divider = () => {
  return <LineDiv></LineDiv>;
};

export default Divider;
